module.exports = __webpack_public_path__ + "assets/wheel-thumb.3dfe195645c4c56d994a84fb222acfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wheel-thumb.png
// module id = 47
// module chunks = 0